import { cn } from '@/lib/utils';
import { Input } from './ui/input';

import * as React from 'react';

interface IconedInputProps extends React.ComponentProps<'input'> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const IconedInput = React.forwardRef<HTMLInputElement, IconedInputProps>(
  ({ className, type, leftIcon, rightIcon, ...props }, ref) => {
    return (
      <div className="relative group min-w-[140px] w-full">
        {leftIcon && (
          <InputIconContainer position="left">{leftIcon}</InputIconContainer>
        )}
        <Input
          type={type}
          className={cn(
            'cursor-pointer',
            leftIcon && 'pl-8',
            rightIcon && 'pr-8',
            className
          )}
          ref={ref}
          {...props}
        />
        {rightIcon && (
          <InputIconContainer position="right">{rightIcon}</InputIconContainer>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

function InputIconContainer({
  children,
  position,
}: {
  children: React.ReactNode;
  position: 'left' | 'right';
}) {
  return (
    <div
      className={cn(
        'absolute top-0 flex items-center h-full',
        position === 'left' ? 'left-0 pl-2' : 'right-0 pr-2'
      )}
    >
      <div className="h-min aspect-square items-center justify-center rounded-full">
        {children}
      </div>
    </div>
  );
}

export { IconedInput };
